import * as React from 'react';
import classNames from 'classnames';
import OutlinedDown from 'acud-icon/lib/icons/OutlinedDown';
import OutlinedUp from 'acud-icon/lib/icons/OutlinedUp';
function renderExpandIcon(locale) {
    return function expandIcon({ prefixCls, onExpand, record, expanded, expandable }) {
        const iconPrefix = `${prefixCls}-row-expand-icon`;
        if (!expandable) {
            return null;
        }
        return (<span onClick={e => {
                onExpand(record, e);
                e.stopPropagation();
            }} className={classNames(iconPrefix)} aria-label={expanded ? locale.collapse : locale.expand}>
                {expanded ? <OutlinedUp /> : <OutlinedDown />}
            </span>);
    };
}
export default renderExpandIcon;
